import React from "react";
import styles from "../Dashboard.module.css";

const MyPublications = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>My Publications</main>
    </div>
  );
};

export default MyPublications;
